function sscInit() {
    var targetEl = document.querySelector(".js-ssc-block");
    var HIDDEN_CLASS = 'is-hidden';

    if ( ! targetEl ) {
        return;
    }

    var toggleButtonEl = targetEl.querySelector(".js-ssc-toggle-button");

    if ( ! toggleButtonEl ) {
        return;
    }

    function sscToggleEvent() {
        targetEl.classList.toggle(HIDDEN_CLASS);
    }

    toggleButtonEl.addEventListener("click", sscToggleEvent);
}

document.addEventListener("DOMContentLoaded", sscInit);
